"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _formik = require("formik");

var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));

var _excluded = ["id", "name", "optionsArray", "followUpOptions", "questions", "subQuestions", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RadioButtonsWithFollowUpRadioButtons = function RadioButtonsWithFollowUpRadioButtons(_ref) {
  var id = _ref.id,
      name = _ref.name,
      optionsArray = _ref.optionsArray,
      followUpOptions = _ref.followUpOptions,
      questions = _ref.questions,
      subQuestions = _ref.subQuestions,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var formik = (0, _formik.useFormikContext)();

  var _useState = (0, _react.useState)(["", "", ""]),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var handleChange = function handleChange(event, valueIndex) {
    var localValue = "";

    if (event.target.value == followUpOptions[valueIndex]) {
      //reset radio buttons
      for (var i = valueIndex; i < 3; i++) {
        localValue = value;
        localValue[i] = "";
        setValue(localValue);
      }

      formik.setFieldValue(name, formik.initialValues[name]);
    } else {
      formik.setFieldValue(name, event.target.value);
    }

    localValue = value;
    localValue[valueIndex] = event.target.value;
    setValue(localValue);
  };

  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    className: className
  }, optionsArray.map(function (options, i) {
    return /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true,
      xs: 11
    }, //if the current question is the first question, or the previous questions followup option was chosen, then show the question
    (i == 0 || value[i - 1] == followUpOptions[convertIntValueToId(i - 1)]) && /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true,
      sx: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true,
      xs: 12
    }, questions[i] != null && /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "h6",
      tabIndex: "0"
    }, questions[i])), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true,
      xs: 11
    }, /*#__PURE__*/_react.default.createElement(_material.RadioGroup, {
      name: "RadioButton",
      value: value[i],
      onChange: function onChange(e) {
        return handleChange(e, i);
      }
    }, options["options"].map(function (choice) {
      return /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
        value: choice["value"],
        control: /*#__PURE__*/_react.default.createElement(_material.Radio, {
          "aria-label": "radio button",
          tabIndex: "0"
        }),
        label: /*#__PURE__*/_react.default.createElement("span", {
          sx: {
            color: value[i] == "" && formik.errors[name] ? "#f44336" : null
          }
        }, choice["radioLabel"]),
        tabIndex: "0"
      });
    }))))));
  }), formik.errors[name] ? /*#__PURE__*/_react.default.createElement(_FormHelperText.default, {
    error: true,
    sx: {
      color: "#f44336"
    }
  }, formik.errors[name]) : null);
};

var _default = RadioButtonsWithFollowUpRadioButtons;
exports.default = _default;

function convertIntValueToId(int) {
  return "followUpOptionId" + int;
}